import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import { LocationService, SoilUnitService, StrategicCommercialZoneService } from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

export const STANDSOIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .date('creationTime', 'Entity.CreationTime')
    .readOnly()
    .build(),
  FieldBuilder
    .number('standSoilArea', 'Entity.StandSoil.StandSoilArea')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('standSoilPercentage', 'Entity.StandSoil.StandSoilPercentage')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .checkbox('isMainSoil', 'Entity.StandSoil.IsMainSoil')
    .build(),
  FieldBuilder.foreignKey(
    'standLocationId',
    'Entity.Stand',
    LocationService
  )
    .required()
    .display('name')
    .displayFromNested('standLocationName')
    .sortBy('standLocationName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'soilUnitId',
    'Entity.StandSoil.SoilUnit',
    SoilUnitService
  )
    .display('name')
    .displayFromNested('soilUnitName')
    .sortBy('soilUnitName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'strategicCommercialZoneId',
    'Entity.StandSoil.StrategicCommercialZone',
    StrategicCommercialZoneService
  )
    .display('name')
    .displayFromNested('strategicCommercialZoneName')
    .sortBy('strategicCommercialZoneName')
    .keyField('id')
    .build(),
];

export const STANDSOIL_CONFIG = {
  entityName: 'StandSoil',
  localizationKey: 'Geographic::Entity.StandSoil',
  fields: STANDSOIL_FIELDS,
  permission: 'PlanningGeography.StandSoils',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
